
'use client'

import { useState } from 'react'
import { supabase } from '@/integrations/supabase/client'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { toast } from '@/components/ui/use-toast'

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [emailSent, setEmailSent] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/change-password`,
      })

      if (error) {
        throw error;
      } 
      
      setEmailSent(true)
      setEmail('')
      toast({
        title: 'Erfolg',
        description: 'E-Mail zum Zurücksetzen wurde versendet',
      })
    } catch (error: any) {
      toast({
        title: 'Fehler',
        description: error.message,
        variant: 'destructive',
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  if (emailSent) {
    return (
      <div className="bg-gray-800/20 border border-gray-700/50 rounded-md p-4">
        <h3 className="text-lg font-semibold mb-2">E-Mail gesendet!</h3>
        <p className="mb-4 text-chrona-gray-300">
          Wir haben dir einen Link zum Zurücksetzen deines Passworts geschickt. 
          Bitte überprüfe dein Postfach und folge den Anweisungen in der E-Mail.
        </p>
        <p className="text-sm text-gray-400">
          Wenn du keine E-Mail erhältst, überprüfe bitte auch deinen Spam-Ordner.
        </p>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="email" className="text-sm font-medium text-gray-300 mb-1 block">
          E-Mail-Adresse
        </label>
        <Input
          id="email"
          type="email"
          placeholder="name@beispiel.de"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="bg-gray-700 border-gray-600 text-white"
        />
      </div>

      <Button 
        type="submit" 
        className="w-full bg-[#2C6E49] hover:bg-[#4C956C] text-white" 
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Sende Link...' : 'Passwort zurücksetzen'}
      </Button>
    </form>
  )
}

export default ForgotPasswordForm
